<app-bar-chart [data]="barData" [comparison]="comparisonName" [isStacked]="true" [stacks]="stacks" [height]="height" [width]="width" [hideLegend]="false" [sort]="false"></app-bar-chart>
